package br.com.htms.inspeccaocampo.ui

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.requiredSize
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.FilterQuality
import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.platform.PlatformServices
import br.com.htms.inspeccaocampo.platform.decodeToImageBitmap
import kotlinx.browser.document

/**
 * Web: desenha no Compose com tamanho fixo em dp (evita o overlay HTML,
 * que no celular multiplicava a altura pelo devicePixelRatio e ficava gigante).
 */
@Composable
actual fun HtmsHeaderLogo(modifier: Modifier) {
    // Remove overlay antigo de deploys anteriores (ficava solto no body).
    DisposableEffect(Unit) {
        document.getElementById("htmsHeaderLogo")?.let { node ->
            node.parentNode?.removeChild(node)
        }
        onDispose { }
    }

    var bitmap by remember { mutableStateOf<ImageBitmap?>(null) }
    LaunchedEffect(Unit) {
        val bytes = PlatformServices.loadBundledAsset("logo_htms_header.png")
            ?: return@LaunchedEffect
        bitmap = decodeToImageBitmap(bytes)
    }
    val bmp = bitmap ?: return
    Image(
        bitmap = bmp,
        contentDescription = "HTMS Energia",
        contentScale = ContentScale.Fit,
        filterQuality = FilterQuality.High,
        modifier = modifier
            .requiredSize(width = HtmsLogoMaxWidth, height = HtmsLogoMaxHeight)
            .clip(RoundedCornerShape(6.dp))
    )
}
